module.exports = __webpack_public_path__ + "img/osmiumbackground-placeholder.11deea18.jpg";